module.exports = __webpack_public_path__ + "img/stripe.32bbcf78.svg";